module.exports = __webpack_public_path__ + "static/media/share.47e8fa96.png";